module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-4b46fc93db521cddc22dced8846d696e.svg";